
import React, { useEffect, useState } from "react";
import Player from "../Player/Player";
import api from '../utils/api';
import Loader from "../lib/components/Loader";
import { Link } from "react-router-dom";
import FranchiseTags from "./FranchiseTags";
import Payouts from "./Payouts";
import DraftOrder from "./DraftOrder";

const handleContractUpdate = (id, contract) => {
    api.post('/api/v2/players/contract/update', {id: id, contract: Number(contract)}).then(() => {
        console.log(`Updated ${id}, ${contract}`);
    }).catch(res => {
        console.error(res);
    });
}

const Admin = () => {
    const [playersNeedingContracts, updatePlayersNeedingContracts] = useState([]);
    const [users, updateUsers] = useState([]);
    const [userListLoading, updateUserListLoading] = useState(true);
    const [rankingsLoading, setRankingsLoading] = useState(false);
    const [rankingsError, setRankingsError] = useState(null);
    const [rankingsSuccess, setRankingsSuccess] = useState(false);
    const [syncLoading, setSyncLoading] = useState(false);
    const [syncError, setSyncError] = useState(null);
    const [syncSuccess, setSyncSuccess] = useState(false);
    const [rosterMovesYear, setRosterMovesYear] = useState(new Date().getFullYear());
    const [rosterMovesSyncLoading, setRosterMovesSyncLoading] = useState(false);
    const [rosterMovesSyncError, setRosterMovesSyncError] = useState(null);
    const [rosterMovesSyncSuccess, setRosterMovesSyncSuccess] = useState(null);

    const handleUpdateRankings = () => {
        setRankingsLoading(true);
        setRankingsError(null);
        setRankingsSuccess(false);
        api.post('/api/v2/players/rankings/update').then(() => {
            setRankingsSuccess(true);
        }).catch((err) => {
            setRankingsError(err?.response?.data?.message || 'Failed to update rankings.');
        }).finally(() => {
            setRankingsLoading(false);
        });
    };

    const handleSyncPlayers = () => {
        setSyncLoading(true);
        setSyncError(null);
        setSyncSuccess(false);
        api.post('/api/v1/players/rankings/sync').then(() => {
            setSyncSuccess(true);
        }).catch((err) => {
            setSyncError(err?.response?.data?.message || 'Failed to sync players.');
        }).finally(() => {
            setSyncLoading(false);
        });
    };

    const handleSyncRosterMoves = () => {
        setRosterMovesSyncLoading(true);
        setRosterMovesSyncError(null);
        setRosterMovesSyncSuccess(null);
        api.post('/api/v1/players/rosterMoves/sync', { year: Number(rosterMovesYear) }).then(({ data }) => {
            setRosterMovesSyncSuccess(`Synced ${data?.inserted ?? 0} new roster move(s) for ${rosterMovesYear}.`);
        }).catch((err) => {
            setRosterMovesSyncError(err?.response?.data?.message || 'Failed to sync roster moves.');
        }).finally(() => {
            setRosterMovesSyncLoading(false);
        });
    };
    
    useEffect(() => {
        api.get('api/v1/players/contract/empty').then(({ data }) => {
            updatePlayersNeedingContracts(data || []);
        }).catch((err) => {
            console.error(`Failed to get players without contracts, ${err}`);
        });
    }, []);

    useEffect(() => {
        updateUserListLoading(true);
        api.get('api/v1/users').then(({ data }) => {
            updateUsers(data || []);
        }).catch((err) => {
            console.error(`Failed to get users, ${err}`);
        }).finally(() => {
            updateUserListLoading(false);
        });
    }, []);

    // get users
    
    return (
        <>
            <h2>Admin</h2>
            <h3>Users</h3>
            <div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Username</th>
                            <th>Email</th>
                            <th>Permissions</th>
                        </tr>
                    </thead>
                    {userListLoading ? <Loader/> : (
                        <tbody>
                            {users.map((user, index) => (
                                <tr key={index}>
                                    <td><Link to={`./userEdit/${user.id}`}>{user.username}</Link></td>
                                    <td>{user.email}</td>
                                    <td>{user.permissions}</td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>
            </div>
            <h3>Fill in remaining contracts</h3>
            <div>
                {playersNeedingContracts.map((player, index) => (
                    <div key={`${player.id}-update-contract-admin`}>
                        <div className="small text-muted mb-1">{player.manager}:</div>
                        <Player index={index} playerData={player} dirtyData={{}} handleContractUpdate={handleContractUpdate} canUpdate={true} />
                    </div>
                ))}
            </div>
            <h3>Franchise Tags</h3>
            <FranchiseTags/>
            <h3>Payouts</h3>
            <Payouts/>
            <h3>Draft Order</h3>
            <DraftOrder/>
            <h3>Rankings</h3>
            <div>
                {rankingsError && <div className="alert alert-danger">{rankingsError}</div>}
                {rankingsSuccess && <div className="alert alert-success">Rankings updated successfully.</div>}
                <button
                    className="btn btn-primary me-2"
                    onClick={handleUpdateRankings}
                    disabled={rankingsLoading}
                >
                    {rankingsLoading ? 'Updating...' : 'Update Rankings'}
                </button>
                {syncError && <div className="alert alert-danger mt-2">{syncError}</div>}
                {syncSuccess && <div className="alert alert-success mt-2">Players synced successfully.</div>}
                <button
                    className="btn btn-primary"
                    onClick={handleSyncPlayers}
                    disabled={syncLoading}
                >
                    {syncLoading ? 'Syncing...' : 'Sync New Players'}
                </button>
            </div>
            <h3>Host Site Roster Moves</h3>
            <div>
                {rosterMovesSyncError && <div className="alert alert-danger">{rosterMovesSyncError}</div>}
                {rosterMovesSyncSuccess && <div className="alert alert-success">{rosterMovesSyncSuccess}</div>}
                <input
                    type="number"
                    className="form-control d-inline-block me-2"
                    style={{ width: '100px' }}
                    value={rosterMovesYear}
                    onChange={(e) => setRosterMovesYear(e.target.value)}
                />
                <button
                    className="btn btn-primary"
                    onClick={handleSyncRosterMoves}
                    disabled={rosterMovesSyncLoading}
                >
                    {rosterMovesSyncLoading ? 'Syncing...' : 'Sync Roster Moves'}
                </button>
            </div>
        </>
    )
};

export default Admin;